<panel width="520">
  <menu always-visible>
    <menuitem (click)="createUser()">{{ 'user.create' | translate }}</menuitem>
  </menu>
  <h1>{{ 'user.list-users' | translate }}</h1>
  <list-view [emptyLabel]="'user.user-list.user-list-empty-label'" class="scrollable">
    <header defaultSort="ascending">{{ 'general.name' | translate }}</header>
    <header>{{ 'general.email' | translate }}</header>
    <header></header>
    <row *listData="let user from users" [highlighted]="selectedUserId == user.id" (action)="setSelectedUserId(user.id)">
      <column>{{ user.name }}</column>
      <column>{{ user.email }}</column>
      <column align-right><icon (click)="$event.stopPropagation(); deleteUser(user)" type="trash-alt" /></column>
    </row>
  </list-view>
</panel>
@if (selectedUserId || createNewUser) {
  <view-user [userId]="selectedUserId" (userIdChange)="setSelectedUserId($event)" />
}
